var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgYearn = function SvgYearn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.796,
    cy: 12.131,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.566 11.83v-1.216a2.825 2.825 0 0 1-1.56-2.534c0-1.557 1.25-2.82 2.79-2.82 1.73 0 2.98 1.263 2.98 2.82 0 .393-.08.767-.272 1.211l-.492-1.617-.986.312.875 3.366 3.395-1.263-.413-.985-1.266.439c.23-.503.274-.872.274-1.463 0-2.18-1.748-3.949-4.095-3.949-2.157 0-3.906 1.768-3.906 3.95a3.948 3.948 0 0 0 2.676 3.749Zm.654-4.788h1.152V17.22H12.22V7.042Zm1.806 6.607v-1.217a3.948 3.948 0 0 1 2.676 3.75c0 2.18-1.749 3.949-3.906 3.949-2.346 0-4.095-1.768-4.095-3.95 0-.59.045-.959.274-1.462l-1.266.439-.413-.985 3.395-1.263.875 3.366-.986.312-.492-1.617c-.192.444-.272.818-.272 1.21 0 1.558 1.25 2.822 2.98 2.822 1.541 0 2.79-1.264 2.79-2.821a2.825 2.825 0 0 0-1.56-2.533Z",
    fill: "#000"
  })));
};

export default SvgYearn;